/**
 * Simple Read More/Read Less functionality
 * Toggles visibility of additional content
 */

function toggleReadMore(button) {
  const readMoreContent = button.nextElementSibling;
  const isExpanded = readMoreContent.style.display !== 'none';
  
  if (isExpanded) {
    // Collapse content
    readMoreContent.style.display = 'none';
    button.textContent = 'Read More';
    button.setAttribute('aria-expanded', 'false');
  } else {
    // Expand content
    readMoreContent.style.display = 'block';
    button.textContent = 'Read Less';
    button.setAttribute('aria-expanded', 'true');
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  // Set initial aria-expanded attributes
  const readMoreButtons = document.querySelectorAll('.read-more-btn');
  readMoreButtons.forEach(button => {
    button.setAttribute('aria-expanded', 'false');
  });
});